/**
 * Project: bicc-trafig
 * Author: Rolf Alberth <rolf.alberth@bicc.de>
 * Last Modified: 2021-12-10 14:30:06
 * License: MIT License
 */

export default {
    all: {
        all: "All"
    },
    gender: {
        1: "Male",
        2: "Female",
        // 3: "Not specified",
        '..': "No data",
    },
    age: {
        1: "16-19",
        2: "20-29",
        3: "30-39",
        4: "40-49",
        5: "50-59",
        6: "60+"
    },
    siteType: {
        1: "Urban site",
        2: "Peri-urban site",
        3: "Rural site"
    },
    maritalStatus: {
        1: "Single",
        2: "Married",
        3: "In partnership, but not married",
        4: "Seperated or divorced",
        5: "Widowed",
        99: "Other"
    }, // martialStatus
    education: {
        0: "None / illiterate",
        1: "Primary school",
        2: "Secondary or high school",
        3: "Tertiary education",
        4: "Other"
    },
    protectionStatus: {
        0: "registered with UNHCR",
        1: "applied for asylum and await decision",
        2: "recognized as beneficiary of protection",
        4: "application rejected",
        99: "never applied",
        100: "status not known" //This change only makes sense when new csv file is used.
    },
    studyCountry: {
        180: "DR Congo",
        231: "Ethiopia",
        300: "Greece",
        380: "Italy",
        400: "Jordan",
        586: "Pakistan",
    },
    originCountry: {
        4: "Afghanistan",
        180: "DR Congo",
        232: "Eritrea",
        586: "Pakistan",
        760: "Syria",
        999: "Other countries",
    },
    IDPCamp: {
        0: "Outside",
        1: "Inside"
    }
}
